import userIcon from "../../../assets/images/userIcon.svg";
import { extractGradientColors } from "../../../general";
import { BrandTheme, HelphubStyleConfig } from "../HelpHub.type";
import { formatDate, getColorVariations, hexToGlassColor } from "./helperfunction";

interface QuestThemeData {
  accentColor?: string;
  borderRadius?: string;
  buttonColor?: string;
  images?: string[];
}

type Props = {
  message: {
    senderRole: "ASSISTANT" | "USER" | "ADMIN";
    content: string;
    timestamp: string;
  };
  index: number;
  fontSize: number | string;
  QuestThemeData?: QuestThemeData;
  BrandTheme?: BrandTheme;
  styleConfig?: HelphubStyleConfig;
};

const HandleUserChat = ({
  message,
  index,
  fontSize,
  QuestThemeData,
  styleConfig,
  BrandTheme,
}: Props) => {


  const wrapLinksInText = (text: string, index: number) => {
    // const urlRegex = /(\bhttps?:\/\/[^\s]+)/gi;
    const urlRegex = /(\bhttps?:\/\/[^\s)]+)/gi; // This stops at ')' in URLs

    const parts = text.split(urlRegex);

    const wrappedText = parts.map((part, index) => {
      if (urlRegex.test(part)) {
        const cleanUrl =
          part.endsWith(".") ||
            part.endsWith(")") ||
            part.endsWith("]") ||
            part.endsWith("}")
            ? part?.slice(0, -1)
            : part;

        return (
          <a
            key={index}
            href={cleanUrl}
            target="_blank"
            style={{ fontSize: fontSize }}
          >
            {cleanUrl}
          </a>
        );
      }
      return part;
    });

    return (
      <p
        style={{
          color:
            styleConfig?.Chat?.SenderMessage?.color
            ||
            BrandTheme?.titleColor
        }}
        key={index}
      >
        {wrappedText}
      </p>
    );
  };


  function formatMessage(message?: string) {
    const messageParagraphs = message?.split("\n").map((line, index) => wrapLinksInText(line, index));
    return messageParagraphs;
  }

  let color = BrandTheme?.primaryColor || QuestThemeData?.accentColor;
  if (color?.includes("gradient")) {
    color = extractGradientColors(color);
  }

  return (
    <>
      <div key={index} style={{ width: "100%" }}>
        <div
          className={`message ${
            message?.senderRole === "USER" ? "sender-role" : "receiver-role"
            }`}
          style={
            // message.senderRole === "USER"
            //   ? { ...styleConfig?.Chat?.SenderMessage }
            //   : { ...styleConfig?.Chat?.RecieverMessege }
            {
              background : hexToGlassColor(BrandTheme?.primaryColor || QuestThemeData?.accentColor),
            }
          }
        >
          {message?.content?.includes("https://quest-media-storage-bucket") ||
            message?.content?.includes("https://pin.questprotocol.xyz/ipfs") ? (
            <div className="chat-coversion-img">
              <img src={message?.content} alt="" />
            </div>
          ) : (
            <>{formatMessage(message?.content)}</>
          )}
        </div>
        <div
          className={`message ${
            message?.senderRole === "USER"
              ? "sender-role sender-time"
              : "receiver-role sender-time"
            }`}
        >
          {formatDate(message.timestamp)}
        </div>
      </div>

      {message?.senderRole === "USER" && (
        <div
          className="chat-profile-img-sender"
          style={{ background: hexToGlassColor(color), borderRadius: "50%" }}
        >
          {/* <img src={userIcon} /> */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
          >
            <path
              d="M9 1.5C7.035 1.5 5.4375 3.0975 5.4375 5.0625C5.4375 6.99 6.945 8.55 8.91 8.6175C8.97 8.61 9.03 8.61 9.075 8.6175C9.09 8.6175 9.0975 8.6175 9.1125 8.6175C9.12 8.6175 9.12 8.6175 9.1275 8.6175C11.0475 8.55 12.555 6.99 12.5625 5.0625C12.5625 3.0975 10.965 1.5 9 1.5Z"
              fill={color || "#9035FF"}
            />
            <path
              d="M12.8102 10.6124C10.7177 9.21741 7.30521 9.21741 5.19771 10.6124C4.24521 11.2499 3.72021 12.1124 3.72021 13.0349C3.72021 13.9574 4.24521 14.8124 5.19021 15.4424C6.24021 16.1474 7.62021 16.4999 9.00021 16.4999C10.3802 16.4999 11.7602 16.1474 12.8102 15.4424C13.7552 14.8049 14.2802 13.9499 14.2802 13.0199C14.2727 12.0974 13.7552 11.2424 12.8102 10.6124Z"
              fill={color || "#9035FF"}
            />
          </svg>
        </div>
      )}
    </>
  );
};

export default HandleUserChat;
